<template>
    <div>
        <common-content-spacer height="medium">
            <common-page-header size="medium" :heading="$t('pages.terms.privacy.heading')" :isCenter="true"></common-page-header>
            <div class="agrement-page">
                <common-content-spacer height="medium">
                    <div class="agrement-page__links">
                        <b v-html="$t('pages.terms.terms.terms_link')"></b>
                        <b v-html="$t('pages.terms.terms.disclaimer_link')"></b>
                    </div>
                    <div>{{ $t('pages.terms.privacy.updated') }}</div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.introduction') }}</b>
                        </p>
                        <p>{{ $t('pages.terms.privacy.welcomeMessage') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.serviceInfo') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataUsageInfo') }}
                        </p>
                        <p v-html="$t('pages.terms.privacy.termsConditions')"></p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.definitions') }}</b>
                        </p>
                        <p>{{ $t('pages.terms.privacy.serviceDefinition') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.personalDataDefinition') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.usageDataDefinition') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.cookiesDefinition') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataControllerDefinition') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProcessorsDefinition') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.dataSubjectDefinition') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.userDefinition') }}
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.infoCollectionUse') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.infoCollectionPurpose') }}
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.typesDataCollected') }}</b>
                        </p>
                        <p>{{ $t('pages.terms.privacy.personalData') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.personalDataInfo') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.usageData') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.usageDataInfo') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.locationData') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.locationDataInfo') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.trackingCookiesData') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.trackingCookiesDataInfo') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.otherData') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.otherDataInfo') }}
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.useData') }}</b>
                        </p>
                        <p>{{ $t('pages.terms.privacy.dataUsePurpose') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataUsePurposesList') }}
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.dataRetention') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataRetentionInfo') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.usageDataRetention') }}
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.dataTransfer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataTransferInfo') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataTransferConsent') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataTransferSecurity') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.disclosureOfData') }}</b>
                        </p>
                        <p>{{ $t('pages.terms.privacy.disclosureDataDescription') }}</p>
                        0.1. {{ $t('pages.terms.privacy.disclosureForLawEnforcement') }}
                        <p>
                            {{ $t('pages.terms.privacy.disclosureForLawEnforcementDescription') }}
                        </p>
                        <p>0.2. {{ $t('pages.terms.privacy.businessTransaction') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.businessTransactionDescription') }}
                        </p>
                        <p>0.3. {{ $t('pages.terms.privacy.otherCases') }}</p>
                        <p>0.3.1. {{ $t('pages.terms.privacy.subsidiariesAndAffiliates') }}</p>
                        <p>0.3.2. {{ $t('pages.terms.privacy.contractorsAndServiceProviders') }}</p>
                        <p>0.3.3. {{ $t('pages.terms.privacy.fulfillPurpose') }}</p>
                        <p>0.3.4. {{ $t('pages.terms.privacy.companyLogo') }}</p>
                        <p>0.3.5. {{ $t('pages.terms.privacy.otherPurpose') }}</p>
                        <p>0.3.6. {{ $t('pages.terms.privacy.withConsent') }}</p>
                        <p>0.3.7. {{ $t('pages.terms.privacy.protectRightsPropertySafety') }}</p>
                    </div>
                    <div>
                        <p>
                            <b>{{ $t('pages.terms.privacy.securityOfData') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.securityOfDataDescription') }}
                        </p>
                        <p>10. {{ $t('pages.terms.privacy.dataProtectionRightsGDPR') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsGDPRDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsGDPRContact') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.dataProtectionRightsGDPRList') }}</p>
                        <p>0.1. {{ $t('pages.terms.privacy.rightToAccessUpdateDelete') }}</p>
                        <p>0.2. {{ $t('pages.terms.privacy.rightOfRectification') }}</p>
                        <p>0.3. {{ $t('pages.terms.privacy.rightToObject') }}</p>
                        <p>0.4. {{ $t('pages.terms.privacy.rightOfRestriction') }}</p>
                        <p>0.5. {{ $t('pages.terms.privacy.rightToDataPortability') }}</p>
                        <p>0.6. {{ $t('pages.terms.privacy.rightToWithdrawConsent') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsGDPRNote') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsGDPRComplain') }}
                        </p>
                        <p>11. {{ $t('pages.terms.privacy.dataProtectionRightsCalOPPA') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCalOPPADescription') }}
                        </p>
                        <p>{{ $t('pages.terms.privacy.dataProtectionRightsCalOPPAList') }}</p>
                        <p>0.1. {{ $t('pages.terms.privacy.calOPPAUsersCanVisitAnonymously') }}</p>
                        <p>0.2. {{ $t('pages.terms.privacy.calOPPAPrivacyPolicyLink') }}</p>
                        <p>0.3. {{ $t('pages.terms.privacy.calOPPAPrivacyPolicyChanges') }}</p>
                        <p>0.4. {{ $t('pages.terms.privacy.calOPPAUsersCanChangePersonalInfo') }}</p>
                        <p>{{ $t('pages.terms.privacy.calOPPAPolicyOnDoNotTrackSignals') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.calOPPADoNotTrackDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.calOPPADoNotTrackEnableOrDisable') }}
                        </p>
                        <p>12. {{ $t('pages.terms.privacy.dataProtectionRightsCCPA') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPADescription') }}
                        </p>
                        <p>0.1. {{ $t('pages.terms.privacy.rightToAccessPersonalInfo') }}</p>
                        <p>0.0.1. {{ $t('pages.terms.privacy.categoriesOfPersonalInfoCollected') }}</p>
                        <p>0.0.2. {{ $t('pages.terms.privacy.categoriesOfSources') }}</p>
                        <p>0.0.3. {{ $t('pages.terms.privacy.businessOrCommercialPurpose') }}</p>
                        <p>0.0.4. {{ $t('pages.terms.privacy.categoriesOfThirdParties') }}</p>
                        <p>0.0.5. {{ $t('pages.terms.privacy.specificPiecesOfPersonalInfo') }}</p>
                        <p>0.0.6. {{ $t('pages.terms.privacy.categoriesOfPersonalInfoSold') }}</p>
                        <p>0.0.7. {{ $t('pages.terms.privacy.categoriesOfPersonalInfoDisclosed') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPANote') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPAStopSelling') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPADeleteInfo') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPASellingImpact') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPAContact') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.dataProtectionRightsCCPAInfoCoveredByCCPA') }}
                        </p>
                        <p>13. {{ $t('pages.terms.privacy.serviceProviders') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.serviceProvidersDescription') }}
                        </p>
                        <p>14. {{ $t('pages.terms.privacy.analytics') }}</p>
                        <p>{{ $t('pages.terms.privacy.analyticsDescription') }}</p>
                        <p>15. {{ $t('pages.terms.privacy.CICDTools') }}</p>
                        <p>{{ $t('pages.terms.privacy.CICDToolsDescription') }}</p>
                        <p>16. {{ $t('pages.terms.privacy.advertising') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.advertisingDescription') }}
                        </p>
                        <p>17. {{ $t('pages.terms.privacy.behavioralRemarketing') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.behavioralRemarketingDescription') }}
                        </p>
                        <p>18. {{ $t('pages.terms.privacy.payments') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.paymentsDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.paymentsPCIDSS') }}
                        </p>
                        <p>19. {{ $t('pages.terms.privacy.linksToOtherSites') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.linksToOtherSitesDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.linksToOtherSitesNoControl') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.linksToOtherSitesPolicyMaker') }}
                        </p>
                        <p>20. {{ $t('pages.terms.privacy.childrensPrivacy') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.childrensPrivacyDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.childrensPrivacyNoCollection') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.childrensPrivacyRemoveData') }}
                        </p>
                        <p>21. {{ $t('pages.terms.privacy.changesToThisPrivacyPolicy') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.changesToThisPrivacyPolicyDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.privacy.changesToThisPrivacyPolicyNotification') }}
                        </p>
                        <p>22. {{ $t('pages.terms.privacy.contactUs') }}</p>
                        <p>
                            {{ $t('pages.terms.privacy.contactUsDescription') }}
                        </p>
                    </div>
                    <div>
                        <p><b></b></p>
                    </div>
                </common-content-spacer>
            </div>
        </common-content-spacer>
    </div>
</template>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .agrement-page {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 50px;
        max-width: 70%;
        margin: 0 auto;
        @include breakpoint(tablet) {
            max-width: 85%;
        }
        @include breakpoint(smartphone-large) {
            max-width: 100%;
        }
        &__links {
            display: flex;
            justify-content: space-evenly;
            @include breakpoint(smartphone-large) {
                justify-content: space-between;
            }
        }

        a {
            color: $color-link;
        }
    }
</style>
